import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { FilterSelectModel, ItemSelectModel } from 'src/app/shared/components/filter-select/filter-select.model';
import { MenuFunctionalityEnum } from 'src/app/shared/menu/menu.functionality.enum';
import { MenuModuleEnum } from 'src/app/shared/menu/menu.module.enum';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { KeyService } from 'src/app/shared/services/API/emerges-key/key.service';
import { KeyModel } from "src/app/shared/services/models/emerges-key/key.model";
import { UtilService } from 'src/app/shared/services/util.service';
import { KeyDeleteModalComponent } from './key-delete-modal/key-delete-modal.component';

@Component({
  selector: 'app-key-list',
  templateUrl: './key-list.component.html',
  styleUrls: ['./key-list.component.css']
})

export class KeyListComponent implements OnInit {

  constructor(private keyService: KeyService,
    private alertService: AlertService,
    private utilService: UtilService,
    public dialog: MatDialog
  ) { }

  public menuModuleEnum:MenuModuleEnum = MenuModuleEnum.support;
  public menuFunctionalityEnum:MenuFunctionalityEnum = MenuFunctionalityEnum.support_key;

  public listKey: KeyModel[];
  public searchText: string;
  public isLoading: boolean;


  ngOnInit(): void {
    this.populateScrean();

    this.listKey == null;
    this.isLoading = true;
    this.searchText = null;
  }

  populateScrean(){
    //Listando key
    this.search();
  }

  private timeoutKeySearch: any = null;

  onKeySearch(event: any) {
    clearTimeout(this.timeoutKeySearch);
    var $this = this;
    this.timeoutKeySearch = setTimeout(function () {
      if (event.keyCode != 13) {
        $this.search();
      }
    }, 1000);
  }

  search(){

    if(this.searchText == "")
      this.searchText = null;

    this.isLoading = true;
    this.keyService.listKey(this.searchText).subscribe((response)=>{
      
      if(response.isError){
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }
      
      this.listKey = response.listKey;  
      this.isLoading = false;    
    },
    (error)=>{
      console.log(error)
      this.isLoading = false;    
      this.alertService.show('Erro inesperado', error, AlertType.error);
    });
  }

  openModal(idKey){
    const dialogRef = this.dialog.open(KeyDeleteModalComponent, {
      data: {
        idKey: idKey
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result && result.deleteKey){
        this.search();
      }
    });
  }
}